import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { Tooltip } from '@osmosis/tailwind-ui/components/tooltip/Tooltip';
import { useColors } from '@osmosis/tailwind-ui/helpers/useColors';
import React from 'react';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';

import { FormattedMessage } from 'react-intl';
import { UserProps } from '@osmosis/shared/types/user';

type Props = {
  title: string;
  learnNodeID: number;
  current: boolean;
  prime?: boolean;
  user: UserProps | null;
  hasPrime: boolean;
  isOnScreen?: boolean;
};

/**
 * Learn sidenav item row name.
 */
const LearnSidenavItemRowName = ({
  title,
  prime,
  user,
  hasPrime,
  isOnScreen,
}: Props) => {
  const colors = useColors();

  return (
    <>
      {title}
      {(!user || !hasPrime) && prime && isOnScreen && (
        <Box className={`text-yellow-400 dark:text-yellow-200 gap-2 px-2`}>
          <Icon icon={faStar} data-tip data-tooltip-id="star-icon" />
          <Tooltip
            id="star-icon"
            style={{
              backgroundColor: colors.text,
              color: colors.textInvert,
            }}
          >
            <P
              color="inherit"
              className={`text-[9px] md:text-[13px] max-w-[120px]`}
            >
              <FormattedMessage
                id="learn.sidenav.star_icon_tooltip"
                defaultMessage="This is an Osmosis Plan video"
              />
            </P>
          </Tooltip>
        </Box>
      )}
    </>
  );
};

export default LearnSidenavItemRowName;
